import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { RootErrorBoundary } from './components/RootErrorBoundary.js';
import './styles/global.css';

const el = document.getElementById('root');
if (!el) throw new Error('root element missing');

/*
  O SEGUNDO BOUNDARY, e por que ele fica AQUI e não em `App`.

  `AppShell` isola a ROTA (dentro do `<main>`), e a posição está certa: mais
  acima levaria o menu junto. O que sobrava fora de qualquer boundary era a
  MOLDURA — `Topbar`, `Sidebar`, o cálculo de `badges` que faz `fetch` — mais
  `ThemeProvider`, `AuthProvider` e o roteador.

  Medido na revisão: um `throw` injetado em `Sidebar` zerava
  `document.body.innerText` e os links de menu. Portal em branco, por fora do
  boundary que existe para impedi-lo.

  Envolvendo `<App/>` aqui, o boundary cobre inclusive os providers e o router —
  o que um boundary declarado DENTRO de `App` não conseguiria fazer, porque um
  componente não captura erro dos seus próprios irmãos acima na árvore.

  DENTRO do `StrictMode`: em desenvolvimento o React relança o erro depois de o
  boundary tratá-lo, e é isso que mantém o `console` útil.
*/
createRoot(el).render(
  <StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </StrictMode>,
);
